// extracted by mini-css-extract-plugin
export default {"wrap":"so-z","logoContainer":"to-z","brandImg":"uo-z","logoImg":"vo-z","logoButton":"wo-z"};